/* eslint-disable
 radix,
 */
import matches from 'lodash/matches'
import forEach from 'lodash/forEach'
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import set from 'lodash/set'
import map from 'lodash/map'
import filter from 'lodash/filter'
import first from 'lodash/first'
import minBy from 'lodash/minBy'
import flow from 'lodash/fp/flow'
import valuesFp from 'lodash/fp/values'
import flattenFp from 'lodash/fp/flatten'
import mapFp from 'lodash/fp/map'
import maxFp from 'lodash/fp/max'
import moment from 'moment'
import d3 from 'd3'

export default Chart

/** @ngInject */
function Chart(Contract, $state, $rootScope, $filter) {
  // For the colors of the charts you have to take into account the 75% of opacity
  // applied by nvd3. See http://stackoverflow.com/questions/12228548/finding-equivalent-color-with-opacity
  // for conversion formulas.
  //
    let info = []

    const setScale = (data) => [0, flow(valuesFp, flattenFp, mapFp('values'), flattenFp, mapFp('y'), maxFp)(data)]

    const watch = {
        data(callback) {
            return $rootScope.$on('chart-updated', (event, chart) => callback(chart))
        },
        activeIndex(callback) {
            return $rootScope.$on('chart-active-index-updated', (event, index) => callback(index))
        },
    }

    const retrieveFilteredData = (values, tempclass) => values.filter(matches({ temp_class: tempclass }))

    const filterValues = function (values) {
        const filteredValues = {
            BASE: { key: 'Base', values: [], type: 'BASE' },
            HP: { key: 'Heures pleine', values: [], type: 'HP' },
            HC: { key: 'Heures creuse', values: [], type: 'HC' },
        }
        forEach(values, (val) => {
            if (val && val.cons_details) {
                // is hphc
                return forEach(Object.keys(val.cons_details), (k) => {
                    const tmpVal = cloneDeep(val)
                    tmpVal.id_p_calendar = k
                    tmpVal.estimatedCons = val.cons_details[k].estimatedCons
                    tmpVal.autoCons = val.cons_details[k].autoCons
                    tmpVal.realCons = val.cons_details[k].realCons
                    return filteredValues[k].values.push(tmpVal)
                })
            } else if (val) {
                // legacy
                if ((val.temp_class === 'HP') || (val.temp_class === 'HC') || (val.temp_class === 'BASE')) {
                    return filteredValues[val.temp_class].values.push(val)
                }
            }
        })

        return map(Object.keys(filteredValues), (k) => filteredValues[k])
    }

    const getMinDateValue = (values) => minBy(values, (value) => moment().year(value.year).month(value.month).toISOString())

    const generateDefaultValuesPerMonth = (minDateValue, numberOfMonth) =>
      map(Array(numberOfMonth), (value, index) => {
          if ((minDateValue.month + index) > 12) {
              return { month: (minDateValue.month + index) % 12, year: minDateValue.year + 1 }
          }
          return { month: minDateValue.month + index, year: minDateValue.year }
      })


    const fillWithExistingValueOrDefault = (values, defaultDateValues) =>
      defaultDateValues.map((defaultValue) => {
          const sameDateValue = filter(values, matches(defaultValue))
          return get(sameDateValue, 0, defaultValue)
      })

    const getActiveIndex = function () {
        for (const value of Array.from(info)) {
            if (value.active) {
                return info.indexOf(value)
            }
        }
    }

    const paintActive = function () {
        const activeIndex = getActiveIndex()
        if (activeIndex !== undefined) {
            $rootScope.$emit('chart-active-index-updated', activeIndex)
            d3.selectAll(`.nv-bar.nv-bar-group-${activeIndex}`)
            .classed({ 'nv-bar-active': true })
            return d3.selectAll(`.nv-bar.nv-bar-group-${activeIndex}.prediction`)
            .style({ fill: 'url(#prediction-active)' })
        }
    }

    const makeActive = function (index) {
        if (info[index].clickable) {
            const activeIndex = getActiveIndex()
            if (activeIndex !== undefined) {
                info[activeIndex].active = false
                d3.selectAll(`.nv-bar.nv-bar-group-${activeIndex}`)
                .classed({ 'nv-bar-active': false })
                d3.selectAll(`.nv-bar.nv-bar-group-${activeIndex}.prediction`)
                .style({ fill: 'url(#prediction)' })
            }

            info[index].active = true
            return paintActive()
        }
    }

    const formatInfoData = function (values) {
        const tmpValues = filterValues(values)
        const isSameDate = (value1) => (value2) => (value1.month === value2.month) && (value1.year === value2.year)
        const getNumber = (object, field) => Number(get(object, field, 0))
        // flow is equivalent to the | in linux allowing to chain output in the next function
        const minDateValue = getMinDateValue(values)
        const toGraphValues = function (values, numberOfMonth) {
            const defaultDateValues = generateDefaultValuesPerMonth(minDateValue, numberOfMonth)
            return (type) => flow((values) => fillWithExistingValueOrDefault(values, defaultDateValues))(values)
        }

        const baseGraphValues = toGraphValues(tmpValues[0].values, 12)()
        const hpGraphValues = toGraphValues(tmpValues[1].values, 12)()
        const hcGraphValues = toGraphValues(tmpValues[2].values, 12)()

        info = baseGraphValues.map((baseValue) => {
            let amountWithModif
            let consumption
            let paid
            let taxes
            const hpValue = first(hpGraphValues.filter(isSameDate(baseValue)))
            const hcValue = first(hcGraphValues.filter(isSameDate(baseValue)))
            const getFirst = (path) => get(baseValue, path, get(hpValue, path, get(hcValue, path)))

            const hasConsDetail = hpValue.cons_details || hcValue.cons_details || baseValue.cons_details

            const date = moment().year(Number(baseValue.year)).month(Number(baseValue.month) - 1)

            const pot = {}
            if (getFirst('earnedPot')) {
                pot.type = 'earned'
                pot.value = $filter('frAmount')((Number(getFirst('earnedPot'))))
            } else if (getFirst('estimatedEarnedPot')) {
                pot.type = 'estimated'
                pot.value = $filter('frAmount')((Number(getFirst('estimatedEarnedPot'))))
            } else if (date.isBefore(moment())) {
                pot.type = 'unknown'
                pot.value = $filter('frAmount')((0))
            } else {
                pot.type = null
                pot.value = 'En attente'
            }

            if (hasConsDetail === undefined) {
                consumption = Number((getNumber(baseValue, 'estimatedConsValued') + getNumber(hpValue, 'estimatedConsValued') + getNumber(hcValue, 'estimatedConsValued')).toPrecision(12))
                amountWithModif = Number((getNumber(baseValue, 'amountWithModif') + getNumber(hpValue, 'amountWithModif') + getNumber(hcValue, 'amountWithModif')).toPrecision(12))
                taxes = Number((getNumber(baseValue, 'taxes') + getNumber(hpValue, 'taxes') + getNumber(hcValue, 'taxes')).toPrecision(12))
            } else {
                consumption = Number((getNumber(baseValue, 'estimatedConsValued') + getNumber(hpValue, 'estimatedConsValued')).toPrecision(12))
                amountWithModif = Number((getNumber(baseValue, 'amountWithModif') + getNumber(hpValue, 'amountWithModif')).toPrecision(12))
                taxes = Number((getNumber(baseValue, 'taxes') + getNumber(hpValue, 'taxes')).toPrecision(12))
            }

            const estimatedCons = {
                base: getNumber(baseValue, 'estimatedCons'),
                hp: getNumber(hpValue, 'estimatedCons'),
                hc: getNumber(hcValue, 'estimatedCons'),
            }

            const subscription = Number(getFirst('subscription'))

            if ((consumption !== undefined) || (subscription !== undefined) || (taxes !== undefined)) {
                paid = $filter('frAmount')((Number((taxes + subscription + consumption).toPrecision(12))))
            } else {
                paid = 'En attente'
            }

            const formattedDate = date.format('MMM YY')
            const clickable = (estimatedCons.base > 0) || (estimatedCons.hp > 0) || (estimatedCons.hc > 0)

            /* Echu // 2018-07 // Echoir */
            const echuEchoirSwitchDate = moment('2018-07', 'YYYY-MM')
            let paymentMonth
            if (date.isSame(echuEchoirSwitchDate, 'month')) {
                paymentMonth = undefined
            } else if (date.isBefore(echuEchoirSwitchDate, 'month')) {
                paymentMonth = moment(date).add(1, 'months').format('MMMM YYYY')
            } else {
                paymentMonth = moment(date).format('MMMM YYYY')
            }

            return {
                active: moment().month() === (Number(baseValue.month) - 1),
                consumption: $filter('frAmount')(consumption),
                date,
                mensuality: date.format('MMMM YYYY'),
                paymentMonth,
                paid,
                pot,
                prediction: getFirst('prediction'),
                subscription: $filter('frAmount')((subscription)),
                taxes: $filter('frAmount')(taxes),
                estimatedCons,
                formattedDate,
                clickable,
                amountWithModifs: amountWithModif,
            }
        })
        return info
    }

    const formatData = function (values) {
        const getEstimatedValue = (value) => get(value, 'correctedCons', get(value, 'estimatedCons', 0))

        const getRealValue = (value) => get(value, 'realCons', get(value, 'autoCons', 0))
        const mapGraphData = (values, type) => {
            const toGraphData = (value, index) => {
                const formattedDate = moment().year(Number(value.year)).month(Number(value.month) - 1).format('MMM YY')
                const numberedDate = `${value.year}-${value.month}`
                const additionnalClass = value.prediction ? ' prediction' : ''
                return [
                    {
                        index,
                        type,
                        x: `${formattedDate} Estimé`,
                        y: Number(getEstimatedValue(value)),
                        barColor: '#93a3b7',
                        classType: `nv-bar-estimated${additionnalClass}`,
                        classGroup: `nv-bar-group-${index}`,
                        numberedDate,
                        tempClass: value.temp_class,
                    },
                    {
                        index,
                        type,
                        x: `${formattedDate} Consommé`,
                        y: Number(getRealValue(value)),
                        barColor: '#071B37',
                        classType: `nv-bar-real${additionnalClass}`,
                        classGroup: `nv-bar-group-${index}`,
                        numberedDate,
                        tempClass: value.temp_class,
                    },
                ]
            }
            return flow(mapFp.convert({ cap: false })(toGraphData), flattenFp)(values)
        }

        const prepareData = function (values) {
            const minDateValue = getMinDateValue(values)
            const defaultDateValues = generateDefaultValuesPerMonth(minDateValue, 12)
            const filteredValues = filterValues(values)
            forEach(filteredValues, (val) => {
                val.values = fillWithExistingValueOrDefault(val.values, defaultDateValues)
                val.values = mapGraphData(val.values, val.type)
            })

            return filteredValues
        }

        return prepareData(values)
    }

    const getOptions = function (opts) {
        const chartHeight = 200
        return {
            multiBarChart: {
                chart: {
                    type: 'multiBarChart',
                    height: chartHeight,
                    margin: {
                        top: 20,
                        right: 15,
                        bottom: 15,
                        left: 15,
                    },
                    clipEdge: true,
                    groupSpacing: 0,
                    duration: 1, // Set to one to avoid
                    stacked: true,
                    showControls: false,
                    showYAxis: false,
                    showXAxis: false,
                    showLegend: false,
                    noData: 'Aucune donnée disponible.',
                    multibar: {
                        dispatch: {
                            renderEnd(e) {
                                if ($state.current.name === 'tracking') {
                                    const nextReadingDate = opts && opts.nextReadingDate ? moment(opts.nextReadingDate).startOf('month').format('YYYY-M') : null

                                    const defs = d3.selectAll('svg').append('defs')
                                    defs.append('pattern')
                                    .attr({
                                        id: 'prediction',
                                        width: '8',
                                        height: '10',
                                        patternUnits: 'userSpaceOnUse',
                                        patternTransform: 'rotate(45 50 50)',
                                    })
                                    .append('line')
                                    .attr({ 'stroke': '#a6a6a6', 'stroke-width': '7px', 'y2': '10' })
                                    defs.append('pattern')
                                    .attr({
                                        id: 'prediction-active',
                                        width: '8',
                                        height: '10',
                                        patternUnits: 'userSpaceOnUse',
                                        patternTransform: 'rotate(45 50 50)',
                                    })
                                    .append('line')
                                    .attr({ 'stroke': '#E97C92', 'stroke-width': '7px', 'y2': '10' })

                                    // for after window resize
                                    d3.selectAll('rect.nv-bar')
                                    .style('stroke', 'white')
                                    .attr('stroke-width', '1px')
                                    .attr('rx', 0)
                                    .style('fill', '')
                                    .each(function (elementData) {
                                        return d3.select(this)
                                        .classed(elementData.classGroup, true)
                                        .classed(elementData.classType, true)
                                    })

                                    d3.selectAll('rect.nv-bar.prediction')
                                    .style('stroke', 'white')
                                    .attr('stroke-width', '1px')
                                    .attr('rx', 2)
                                    .style('fill', 'url(#prediction)')
                                    .each(function (elementData) {
                                        return d3.select(this)
                                        .classed(elementData.classGroup, true)
                                        .classed(elementData.classType, true)
                                    })

                                    paintActive()

                                    return d3.selectAll('rect.nv-bar')
                                    .each(function (elementData) {
                                        // check if set of data is reading month
                                        elementData.isReadingMonth = (elementData.numberedDate === nextReadingDate)
                                        const el = d3.select(this)
                                        const id = `bar-${elementData.numberedDate}-${elementData.type}`
                                        el.attr('id', id)

                                        // add reading date marker
                                        const rDeL = d3.select('#reading-date')
                                        const addMarker = (() => {
                                            if ((opts.plan === 'Heures creuses') && (elementData.type === 'HC')) {
                                                return true
                                            } else if (opts.plan === 'Base') {
                                                return true
                                            }
                                        })()
                                        if (elementData.isReadingMonth && addMarker) {
                                            let seriesNumber = 2
                                            switch (elementData.type) {
                                                case 'BASE': seriesNumber = 0; break
                                                case 'HP': seriesNumber = 1; break
                                                case 'HC': seriesNumber = 2; break
                                                default: seriesNumber = 2
                                            }
                                            const series = `.nv-series-${seriesNumber}`
                                            if (rDeL.empty()) {
                                                const readingMarker = d3.select(series).insert('line', `#${id} + *`)
                                                readingMarker.attr('id', 'reading-date')
                                                .style('stroke', 'black')
                                                .style('fill', 'black')
                                                .attr('stroke-width', '1.5px')
                                                .attr('y1', parseInt(chartHeight))
                                                .attr('y2', '-60')
                                                .attr('transform', el.attr('transform'))

                                                const txt = d3.select(series)
                                                .insert('text', `#${id} + *`)
                                                txt
                                                .attr('x', 10)
                                                .attr('y', -20)
                                                .attr('transform', el.attr('transform'))
                                                .attr('stroke-width', '0')
                                                .attr('fill', '#455469')
                                                .attr('class', 'reading-label')

                                                txt
                                                .insert('tspan')
                                                .html('Prochaine relève')
                                                .attr({ x: 10, dy: '2.4em' })
                                                txt
                                                .insert('tspan')
                                                .html('Enedis')
                                                .attr({ x: 10, dy: '1.2em' })

                                                d3.select(series)
                                                .insert('rect', `#${id} + *`)
                                                .attr('y', -17)
                                                .attr('stroke-width', '0')
                                                .attr('fill', 'rgba(255,255,255,0.5)')
                                                .attr('transform', el.attr('transform'))
                                                .attr({ width: '135' })
                                                .attr({ height: '2.4em' })
                                            }
                                        }

                                        if (rDeL.empty() === false) {
                                            el.append('pattern')
                                            .attr({
                                                id: 'prediction',
                                                width: '8',
                                                height: '10',
                                                patternUnits: 'userSpaceOnUse',
                                                patternTransform: 'rotate(45 50 50)',
                                            })
                                            .append('line')
                                            .attr({ 'stroke': '#a6a6a6', 'stroke-width': '7px', 'y2': '10' })
                                            el.append('pattern')
                                            .attr({
                                                id: 'prediction-active',
                                                width: '8',
                                                height: '10',
                                                patternUnits: 'userSpaceOnUse',
                                                patternTransform: 'rotate(45 50 50)',
                                            })
                                            .append('line')
                                            .attr({ 'stroke': '#E97C92', 'stroke-width': '7px', 'y2': '10' })
                                        }

                                        const width = el.attr('width')
                                        const reducedWidth = width * 0.7
                                        const marginLeft = (elementData.classType != null ? elementData.classType.indexOf('nv-bar-estimated') : undefined) > -1 ? width - reducedWidth : 0

                                        return el
                                        .attr('width', reducedWidth)
                                        .attr('x', marginLeft)
                                    })
                                }
                            },

                            elementClick(element) {
                                return makeActive(element.data.index)
                            },
                        },
                    },
                    useInteractiveGuideline: false,
                    tooltip: {
                        contentGenerator(data) {
                            let content = `<div class='tooltip-header'>${data.value}</div>`
                            data.series.forEach((serie) => {
                                if (serie.value) {
                                    content += '<i class=\'fa fa-circle\' style=\'color: '
                                    content += `${serie.color}'></i> ${serie.key} : `
                                    content += `${serie.value} kWh`
                                }
                            })
                            return content
                        },
                        distance: 30,
                        gravity: 's',
                    },
                    callback() {
                        d3.selectAll('rect.nv-bar')
                        .style('stroke', 'white')
                        .attr('stroke-width', '1px')
                        .attr('rx', 2)
                        .style('fill', '')

                        d3.selectAll('rect.nv-bar.prediction')
                        .style('stroke', 'white')
                        .attr('stroke-width', '1px')
                        .attr('rx', 2)
                        .style('fill', 'url(#prediction)')

                        return paintActive()
                    },
                },
            },
        }
    }

    const generateGraphData = function (contractCons, opts) {
        const data = formatData(contractCons)
        const overrideOptions = set(getOptions(opts), 'multiBarChart.chart.forceY', setScale(data))
        return {
            data,
            options: overrideOptions,
            info: formatInfoData(contractCons),
            makeActive,
        }
    }

    return {
        options: getOptions(),
        watch,
        setScale,
        utils: {
            generateGraphData,
            makeActive,
            retrieveFilteredData,
            formatData,
            formatInfoData,
        },
    }
}



// WEBPACK FOOTER //
// ./src/services/conso/chart.js